import * as Yup from "yup";

export const provinceValidationSchema = Yup.object().shape({
  province_name: Yup.string()
    .trim()
    .min(2, "Province name must be at least 2 characters")
    .max(100, "Province name cannot exceed 100 characters")
    .required("Province name is required"),

  province_code: Yup.string().trim().required("Province code is required"),

  country_id: Yup.string().trim().required("Please select a country"),
});
